(() => {
  const SELECTOR = '[data-hn-routine-navigator]';

  function initRoutineNavigator(section) {
    if (!section || section.dataset.hnRoutineInitialized === 'true') return;

    const track = section.querySelector('[data-hn-routine-track]');
    const prev = section.querySelector('[data-hn-routine-prev]');
    const next = section.querySelector('[data-hn-routine-next]');
    const activeItem = section.querySelector('.hn-routine-navigator__item.is-active');

    if (!track) return;

    section.dataset.hnRoutineInitialized = 'true';

    let autoplayTimer = null;
    let userInteracted = false;
    const autoplayEnabled = section.dataset.autoplay === 'true';
    const autoplaySpeed = Number(section.dataset.autoplaySpeed || 5000);

    const stopAutoplay = () => {
      userInteracted = true;
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    };

    const scrollByAmount = (amount) => {
      track.scrollBy({ left: amount, behavior: 'smooth' });
    };

    const scrollNext = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const nearEnd = track.scrollLeft >= maxScroll - 12;

      if (nearEnd) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        scrollByAmount(Math.min(132, track.clientWidth * 0.55));
      }
    };

    if (activeItem) {
      window.setTimeout(() => {
        activeItem.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }, 280);
    }

    if (prev) {
      prev.addEventListener('click', () => {
        stopAutoplay();
        scrollByAmount(-Math.min(280, track.clientWidth * 0.75));
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        stopAutoplay();
        scrollByAmount(Math.min(280, track.clientWidth * 0.75));
      });
    }

    section.addEventListener('mouseenter', stopAutoplay, { once: true });
    section.addEventListener('touchstart', stopAutoplay, { once: true, passive: true });
    track.addEventListener('wheel', stopAutoplay, { once: true, passive: true });
    track.addEventListener('pointerdown', stopAutoplay, { once: true });

    if (autoplayEnabled && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.setTimeout(() => {
        if (userInteracted) return;
        autoplayTimer = window.setInterval(() => {
          if (!userInteracted) scrollNext();
        }, autoplaySpeed);
      }, 5000);
    }
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initRoutineNavigator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(SELECTOR).forEach(initRoutineNavigator);
  });
})();